var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventsMenuActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.244,
    height: 28,
    viewBox: "0 0 29.244 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "party_4381520",
    transform: "translate(-0.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39798",
    "data-name": "Path 39798",
    d: "M13.444,2.142a.892.892,0,1,0-1.785,0v3.91q-.222.021-.441.053A6.584,6.584,0,0,0,10,8.022a14.323,14.323,0,0,0-.9,2.932,32.478,32.478,0,0,1,6.91,0,14.322,14.322,0,0,0-.9-2.932,6.585,6.585,0,0,0-1.217-1.916q-.219-.032-.441-.053Z",
    transform: "translate(2.321 0)",
    fill: "#37d16f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39799",
    "data-name": "Path 39799",
    d: "M5.534,10.955a18.813,18.813,0,0,1,2.533-.636,16.729,16.729,0,0,1,1.14-3.929q.084-.19.174-.373a9.252,9.252,0,0,0-4.7,5.253C4.956,11.159,5.24,11.053,5.534,10.955Z",
    transform: "translate(1.133 1.229)",
    fill: "#37d16f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39800",
    "data-name": "Path 39800",
    d: "M15.542,6.391q-.084-.19-.174-.373a9.251,9.251,0,0,1,4.7,5.253c-.27-.113-.554-.218-.849-.316a18.809,18.809,0,0,0-2.533-.636A16.733,16.733,0,0,0,15.542,6.391Z",
    transform: "translate(3.862 1.229)",
    fill: "#37d16f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39801",
    "data-name": "Path 39801",
    d: "M12.617,10.75a29.5,29.5,0,0,1,3.737.23,22.782,22.782,0,0,1,.13,2.447,22.782,22.782,0,0,1-.13,2.447,29.5,29.5,0,0,1-3.737.23,29.5,29.5,0,0,1-3.738-.23,23.13,23.13,0,0,1,0-4.894A29.5,29.5,0,0,1,12.617,10.75Z",
    transform: "translate(2.255 2.452)",
    fill: "#37d16f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39802",
    "data-name": "Path 39802",
    d: "M16.765,13.342c0,.73-.031,1.445-.092,2.14a16.017,16.017,0,0,0,1.73-.462,7.328,7.328,0,0,0,1.9-.894q.032-.387.033-.783t-.033-.783a7.328,7.328,0,0,0-1.9-.894,16.016,16.016,0,0,0-1.73-.462c.06.695.092,1.41.092,2.14Z",
    transform: "translate(4.149 2.536)",
    fill: "#37d16f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39803",
    "data-name": "Path 39803",
    d: "M12.551,16.779a31.729,31.729,0,0,0,3.455-.184,14.324,14.324,0,0,1-.9,2.932,6.586,6.586,0,0,1-1.217,1.916,9.342,9.342,0,0,1-2.667,0A6.585,6.585,0,0,1,10,19.527,14.325,14.325,0,0,1,9.1,16.6,31.73,31.73,0,0,0,12.551,16.779Z",
    transform: "translate(2.321 4.141)",
    fill: "#37d16f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39804",
    "data-name": "Path 39804",
    d: "M15.542,20.448q-.084.19-.174.373a9.251,9.251,0,0,0,4.7-5.253c-.27.113-.554.218-.849.316a18.824,18.824,0,0,1-2.533.636A16.735,16.735,0,0,1,15.542,20.448Z",
    transform: "translate(3.862 3.69)",
    fill: "#37d16f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39805",
    "data-name": "Path 39805",
    d: "M9.208,20.448q.084.19.174.373a9.251,9.251,0,0,1-4.7-5.253c.27.113.554.218.849.316a18.828,18.828,0,0,0,2.533.636A16.731,16.731,0,0,0,9.208,20.448Z",
    transform: "translate(1.133 3.69)",
    fill: "#37d16f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39806",
    "data-name": "Path 39806",
    d: "M6.182,15.019a16.02,16.02,0,0,0,1.73.462c-.06-.695-.092-1.41-.092-2.14s.031-1.445.092-2.14a16.02,16.02,0,0,0-1.73.462,7.326,7.326,0,0,0-1.9.894q-.033.387-.033.783t.033.783a7.326,7.326,0,0,0,1.9.894Z",
    transform: "translate(1.011 2.536)",
    fill: "#37d16f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39807",
    "data-name": "Path 39807",
    d: "M21.954,1.833a.892.892,0,0,0-1.674,0l-.661,1.787-1.787.661a.892.892,0,0,0,0,1.674l1.787.661L20.28,8.4a.892.892,0,0,0,1.674,0l.661-1.787L24.4,5.954a.892.892,0,0,0,0-1.674l-1.787-.661Z",
    transform: "translate(4.51 0)",
    fill: "#37d16f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39808",
    "data-name": "Path 39808",
    d: "M4.117,17.25a.892.892,0,0,1,.837.583l.661,1.787L7.4,20.28a.892.892,0,0,1,0,1.674l-1.787.661L4.954,24.4a.892.892,0,0,1-1.674,0l-.661-1.787L.833,21.954a.892.892,0,0,1,0-1.674l1.787-.661.661-1.787A.892.892,0,0,1,4.117,17.25Z",
    transform: "translate(0 4.265)",
    fill: "#37d16f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsMenuActiveIcon);
export default __webpack_public_path__ + "static/media/events_menu_active_icon.fec3fc7a34d8d6c38eae5a77617bdaa0.svg";
export { ForwardRef as ReactComponent };